import DashboardModel from "@/models/dashboard/dashboardModel";
import nfetch from "@/utils/events/nfetch";

import { IService } from "./base/iService";

export default class DashboardService extends IService<DashboardModel> {
    constructor() {
        super("Dashboard");
    }

    public getEvolucaoVendas(
        franquiaIds: number[],
        dataInicial: Date,
        dataFinal: Date,
        taxaEntrega: boolean,
        tipoVenda: number,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetEvolucaoVendas?${this.filtrosData(
                dataInicial,
                dataFinal,
                taxaEntrega,
                tipoVenda,
            )}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(franquiaIds),
            },
        );
    }

    public getManipulacoes(
        franquiaIds: number[],
        dataInicial: Date,
        dataFinal: Date,
        taxaEntrega: boolean,
        tipoVenda: number,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetManipulacoes?${this.filtrosData(
                dataInicial,
                dataFinal,
                taxaEntrega,
                tipoVenda,
            )}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(franquiaIds),
            },
        );
    }

    public getTotaisPorCategoria(
        franquiaIds: number[],
        dataInicial: Date,
        dataFinal: Date,
        taxaEntrega: boolean,
        tipoVenda: number,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetTotaisPorCategoria?${this.filtrosData(
                dataInicial,
                dataFinal,
                taxaEntrega,
                tipoVenda,
            )}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(franquiaIds),
            },
        );
    }

    private filtrosData(dataInicial: Date, dataFinal: Date, taxaEntrega: boolean, tipoVenda: number): string {
        return `dataInicial=${dataInicial ? dataInicial.toJSON() : ""}&dataFinal=${
            dataFinal ? dataFinal.toJSON() : ""
        }&taxaEntrega=${taxaEntrega}&tipoVenda=${tipoVenda}`;
    }

    public async getManipulacoesPorHoraByEtapa(data: Date, etapaId: number) {
        const response = await nfetch(
            `/${this.controllerName}/GetManipulacoesPorHoraByEtapa?dataInicio=${data.toJSON()}&etapaId=${etapaId}`,
            {
                method: "get",
                credentials: "same-origin",
            },
        );
        return response.json();
    }

    public getDashboardProdutosVendidos(
        franquiaIds: number[] | null,
        dataInicial: Date,
        dataFinal: Date,
        grupoProdutoId: number | null,
        tipoVenda: number | null,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetDashboardProdutosVendidos?dataInicial=${
                dataInicial ? dataInicial.toJSON() : ""
            }&dataFinal=${dataFinal ? dataFinal.toJSON() : ""}&grupoProdutoId=${
                grupoProdutoId ?? ""
            }&tipoVenda=${tipoVenda}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(franquiaIds),
            },
        );
    }

    public getTodosProdutosVendidos(
        franquiaIds: number[] | null,
        dataInicial: Date,
        dataFinal: Date,
        grupoProdutoId: number | null,
        tipoVenda: number | null,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetTodosProdutosVendidos?dataInicial=${
                dataInicial ? dataInicial.toJSON() : ""
            }&dataFinal=${dataFinal ? dataFinal.toJSON() : ""}&grupoProdutoId=${
                grupoProdutoId ?? ""
            }&tipoVenda=${tipoVenda}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(franquiaIds),
            },
        );
    }
}
